import './Footer.svelte.css';
/* src/components/Footer.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	text
} from "../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let footer;
	let div0;
	let t1;
	let div1;
	let a;
	let t2;

	return {
		c() {
			footer = element("footer");
			div0 = element("div");
			div0.textContent = "© 2021 Eka @ekafyi ☕️";
			t1 = space();
			div1 = element("div");
			a = element("a");
			t2 = text("github");
			attr(a, "class", "jd-inline-action");
			attr(a, "href", GH_URL);
			attr(a, "rel", "external");
			attr(footer, "class", "svelte-1kt52e6");
		},
		m(target, anchor) {
			insert(target, footer, anchor);
			append(footer, div0);
			append(footer, t1);
			append(footer, div1);
			append(div1, a);
			append(a, t2);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(footer);
		}
	};
}

const GH_URL = "https://github.com/ekafyi/johnnydecimal-index-generator";

class Footer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Footer;